import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';

import AutorenewIcon from '@material-ui/icons/Autorenew';

import { Layout } from '../../layouts/private/Private';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import Title from '../../components/Title/Title';
import Toast from '../../components/Toast/Toast';
import Loading from '../../components/Loading/Loading';
import SelectOption from '../../components/Inputs/Select/Select';
import Checkbox from '../../components/Inputs/CheckBox/CheckBox';
import Cache from '../Relatorio/Cache';

import Cards from '../../components/Acompanhamento/Cards';
import ProgressoProcesso from '../../components/Acompanhamento/ProgressoProcesso';
import FiltrosDialog from '../../components/Acompanhamento/FiltrosDialog';
import Funil from '../../components/Acompanhamento/Funil';
import Evolucao from '../../components/Acompanhamento/Evolucao';
import TabelaRegioes from '../../components/Acompanhamento/TabelaRegioes';
import Checks from '../../components/Acompanhamento/Checks';
import DownloadApps from '../../components/DownloadApps/DownloadApps';

import RegiaoFilter from '../../forms/Acompanhamento/RegiaoFilter';

import AcompanhamentoService from '../../services/Acompanhamento';
import { errors } from '../../services/API';

import { download } from '../../helper/FileHelper';

import { isAdministradorOuCentral, isCoordenadorOuApoioSecretarial } from '../../security/AuthorizedFunction';

const PERIODO_OPTIONS = [
    { value: 'HOJE', label: 'Hoje' },
    { value: '3D', label: '3 dias' },
    { value: '7D', label: '7 dias' },
    { value: '15D', label: '15 dias' },
    { value: '30D', label: '30 dias' },
    { value: '60D', label: '60 dias' },
];

const PERIODO_PADRAO = '30D';

const INTERVALO_AUTO_REFRESH = 5 * 60 * 1000;

export class Acompanhamento extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visaoGeral: null,
            regioes: [],
            evolucao: [],
            checks: [],
            periodo: PERIODO_PADRAO,
            buscarRegiaoGrupo: false,
            regiao: '',
            ultimaChamada: '',
            loading: true,
        }
    }

    setToast = t => this.Toast = t;
    setRegiaoFilter = r => this.RegiaoFilter = r;

    filtrosBase = (forceRefresh = false) => {
        const f = [];
        const regiao = this.RegiaoFilter?.state?.filters?.regiao;

        if (regiao) f.push({ field: 'regiao', value: regiao });
        f.push({ field: 'buscarRegiaoGrupo', value: this.state.buscarRegiaoGrupo });
        f.push({ field: 'forceRefresh', value: forceRefresh });

        return f;
    }

    carregarTudo = (forceRefresh = false, silent = false) => {
        const regiao = this.RegiaoFilter?.state?.filters?.regiao || '';

        this.setState(silent ? { regiao } : { loading: true, regiao });

        const filtros = this.filtrosBase(forceRefresh);
        const filtrosEvolucao = [...filtros, { field: 'periodo', value: this.state.periodo }];
        const filtrosChecks = [{ field: 'forceRefresh', value: forceRefresh }];

        const chamadas = [
            AcompanhamentoService.visaoGeral(filtros)
                .then(res => this.setState({
                    visaoGeral: res.data.cache,
                    ultimaChamada: res.data.ultimaChamadaFormatada,
                })),
            AcompanhamentoService.porRegiao(filtros)
                .then(res => this.setState({ regioes: [...res.data.cache] })),
            AcompanhamentoService.evolucao(filtrosEvolucao)
                .then(res => this.setState({ evolucao: [...res.data.cache] })),
        ];

        if (isAdministradorOuCentral())
            chamadas.push(
                AcompanhamentoService.checks(filtrosChecks)
                    .then(res => this.setState({ checks: [...res.data.cache] }))
            );

        Promise.all(chamadas)
            .then(() => this.setState({ loading: false }))
            .catch(error => {
                const e = errors(error);
                this.setState({ loading: false });

                this.Toast.setState({
                    message: {
                        message: e.message,
                        type: e.type,
                        open: true
                    }
                })
            });
    }

    handlePeriodoChange = e => this.setState({ periodo: e.target.value });

    handleChecked = e => this.setState({ [e.target.name]: e.target.checked });

    ApplyFilters = () => this.carregarTudo(true);

    countFiltros = () => {
        let count = 0;
        if (this.RegiaoFilter?.state?.filters?.regiao) count += 1;
        if (this.state.periodo !== PERIODO_PADRAO) count += 1;
        if (this.state.buscarRegiaoGrupo) count += 1;
        return count;
    }

    resumoFiltros = () => {
        const regiao = this.RegiaoFilter?.state?.filters?.regiao || 'Todas';
        const periodo = PERIODO_OPTIONS.find(o => o.value === this.state.periodo);
        const partes = [`Região: ${regiao}`, `Período: ${periodo ? periodo.label : this.state.periodo}`];
        if (this.state.buscarRegiaoGrupo) partes.push('Inclui Região Grupo');
        return partes.join('   ·   ');
    }

    handleFilterClear = () => {
        this.RegiaoFilter.setState({ filters: { regiao: this.RegiaoFilter.regiaoDoPerfil() } });
        this.setState({ periodo: PERIODO_PADRAO, buscarRegiaoGrupo: false });
    }

    handleExport = () => {
        this.Toast.setState({
            message: {
                message: "A Planilha está sendo gerada para Exportação.",
                type: 'info',
                open: true,
                loading: true,
                autoHide: false,
            }
        })

        AcompanhamentoService.exportPorRegiao([...this.filtrosBase(true), { field: 'exportarPlanilha', value: true }])
            .then(res => download(res))
            .catch(error => {
                const e = errors(error);

                this.Toast.setState({
                    message: {
                        message: e.message,
                        type: e.type,
                        open: true
                    }
                })
            })
    }

    componentDidMount() {
        this.carregarTudo();
        this.autoRefresh = setInterval(() => this.carregarTudo(true, true), INTERVALO_AUTO_REFRESH);
    }

    componentWillUnmount() {
        clearInterval(this.autoRefresh);
    }

    render() {
        const pageName = 'Acompanhamento de Provas';
        const regiaoProcesso = this.state.regiao
            || this.RegiaoFilter?.state?.filters?.regiao
            || this.RegiaoFilter?.regiaoDoPerfil?.()
            || '';
        const links = [
            {
                path: null,
                name: 'Logística Reversa'
            }
        ];

        return (
            <Layout>
                <Toast parentRef={this.setToast} />
                <Grid container >
                    <Grid item xs={12}>
                        <Breadcrumbs links={links} active={pageName} />
                    </Grid>
                </Grid>
                <Box display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap">
                    <Title>
                        {pageName}
                        { this.state.ultimaChamada &&
                            <Cache ultimaAtualizacao={this.state.ultimaChamada} action={() => this.carregarTudo(true)} />
                        }
                    </Title>

                    <Tooltip title="O painel é recarregado automaticamente a cada 5 minutos." TransitionComponent={Zoom}>
                        <Chip variant="outlined" icon={<AutorenewIcon />} label="Atualização Automática: 5 min" />
                    </Tooltip>
                </Box>

                <FiltrosDialog
                    resumo={this.resumoFiltros()}
                    activeCount={this.countFiltros()}
                    onApply={this.ApplyFilters}
                    onClear={this.handleFilterClear}
                    extra={<DownloadApps />}
                >
                    <Grid item xs={12}>
                        <RegiaoFilter parentRef={this.setRegiaoFilter} />
                    </Grid>

                    <Grid item xs={12}>
                        <SelectOption
                            hiddenblank
                            label="Período"
                            name='periodo'
                            value={this.state.periodo}
                            onChange={this.handlePeriodoChange}
                            options={PERIODO_OPTIONS}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Checkbox
                            label="Buscar Provas de Toda Região Grupo"
                            name='buscarRegiaoGrupo'
                            checked={this.state.buscarRegiaoGrupo}
                            onChange={this.handleChecked}
                        />
                    </Grid>
                </FiltrosDialog>

                { this.state.loading ?
                    <Loading />
                :
                    <div style={{ paddingTop: 16 }}>
                        { (isCoordenadorOuApoioSecretarial() || !!regiaoProcesso) &&
                            <ProgressoProcesso
                                visaoGeral={this.state.visaoGeral}
                                regiao={regiaoProcesso}
                                incluiGrupo={this.state.buscarRegiaoGrupo}
                            />
                        }

                        <Cards visaoGeral={this.state.visaoGeral} buscarRegiaoGrupo={this.state.buscarRegiaoGrupo} />

                        <Grid container spacing={3} style={{ marginTop: 8 }}>
                            <Funil visaoGeral={this.state.visaoGeral} />
                            <Evolucao evolucao={this.state.evolucao} />
                        </Grid>

                        <Grid container spacing={3} style={{ marginTop: 8 }}>
                            <TabelaRegioes
                                regioes={this.state.regioes}
                                podeExportar={isAdministradorOuCentral()}
                                onExport={this.handleExport}
                            />
                        </Grid>

                        { isAdministradorOuCentral() &&
                            <Grid container spacing={3} style={{ marginTop: 8 }}>
                                <Checks checks={this.state.checks} />
                            </Grid>
                        }
                    </div>
                }
            </Layout>
        )
    }
}

export default withRouter(Acompanhamento);
